/** Reports lug'ati (ru) */
export default {
  title: "Отчёты",
  subtitle: "{{scope}} · {{period}} к {{prev}}",
  tabs: { recruiters: "Рекрутеры", sources: "Источники", carriers: "Перевозчики", branches: "Филиалы", funnel: "Воронка", retention: "Удержание", trends: "Тренды", finance: "Финансы" },
  scope: { all: "Все филиалы", branch: "Филиал" },
  filters: { branch: "Филиал", recruiter: "Рекрутер", allBranches: "Все филиалы", myBranches: "Все мои филиалы", locked: "{{branch}} · закреплён", allRecruiters: "Все рекрутеры" },
  recruiters: {
    funnel: "Воронка · {{month}}",
    retentionTitle: "Удержание нанятых",
    retentionSub: "по подтверждённым наймам; доля всё ещё работающих через N дней",
    title: "Рекрутеры · {{count}}",
    sub: "Цифры берутся из истории статусов. В «Нанято» учитываются только подтверждённые менеджером наймы.",
    cols: { recruiter: "Рекрутер", new: "Новые", contacted: "Связались", qualified: "Подходят", submitted: "Отправлено", hired: "Нанято", conv: "Конв.", retention: "Удержание 30/60/90", avgTime: "Ср. время найма", topLoss: "Главная причина потери", calls: "Звонки" },
    empty: "В этой области нет рекрутеров.",
    pending: "+{{count}} в ожидании",
    total: "Итого",
    showing_one: "Показан {{count}} рекрутер",
    showing_few: "Показано {{count}} рекрутера",
    showing_many: "Показано {{count}} рекрутеров",
    showing_other: "Показано {{count}} рекрутера",
  },
  sources: {
    title: "По источникам", sub: "какой источник приводит водителей, которых действительно нанимают",
    cols: { source: "Источник", new: "Новые", hired: "Нанято", conversion: "Конверсия" },
    empty: "За этот период водителей нет.", chart: "Новые и нанятые", new: "Новые", hired: "Нанято",
  },
  carriers: {
    title: "По перевозчикам", sub: "отправки за период и что по ним вернулось",
    cols: { carrier: "Перевозчик", submitted: "Отправлено", hired: "Нанято", rejected: "Отказано", rate: "Доля отказов", reasons: "Основные причины" },
    empty: "За этот период отправок нет.",
  },
  branches: { title: "Филиалы рядом", sub: "Колонки бюджета берутся из модуля «Бюджет»" },
  funnel: { title: "Полная воронка · {{period}}", sub: "водители, дошедшие до каждого этапа за период; % = от предыдущего этапа", lossTitle: "Где теряются водители", lossSub: "причины для «Отказано» / «Не заинтересован» / «Ушёл»" },
  retention: {
    card: "Удержание {{days}} дней",
    stillWorking: "{{retained}} из {{eligible}} нанятых всё ещё работают",
    none: "наймов старше {{days}} дней пока нет",
    title: "Удержание нанятых",
    sub: "подтверждённые наймы, у которых дата начала старше N дней; ушедшие считаются потерянными",
  },
  periodPicker: { kind: "Тип периода", month: "Месяц", quarter: "Квартал", year: "Год", range: "Свои даты", from: "С", to: "По", value: "Период" },
  export: { button: "Excel", title: "Скачать эту вкладку в Excel (те же фильтры и период)" },
  delta: { none: "не с чем сравнить", same: "без изменений", new: "раньше не было", pp: "{{value}} п.п.", vs: "Сравнение с: {{period}}" },
  summary: { new: "Новые водители", submitted: "Отправлено перевозчикам", hired: "Нанято", conversion: "Конверсия", timeToHire: "Дней до найма", days: "{{n}} дн.", lost: "Потеряно" },
  trends: {
    hiresTitle: "Новые водители и наймы · 12 месяцев",
    hiresSub: "Наймы — одобренные; конверсия = наймы / новые водители месяца",
    series: { new: "Новые водители", hired: "Нанято", conversion: "Конверсия" },
    sourcesTitle: "Новые водители по источникам · 12 месяцев",
    sourcesSub: "Откуда приходят водители, по месяцам",
    otherSources: "Другие источники",
    empty: "В эти месяцы новых водителей нет.",
    tableTitle: "По месяцам",
    col: { month: "Месяц", contacted: "Контакт", submitted: "Отправлено", lost: "Потеряно" },
  },
  finance: {
    branchOnly: "Деньги считаются по филиалу: фильтр по рекрутеру не меняет эту вкладку.",
    noFeeAmount_one: "У {{count}} найма нет суммы оплаты перевозчика, поэтому доход показан меньше реального.",
    noFeeAmount_few: "У {{count}} наймов нет суммы оплаты перевозчика, поэтому доход показан меньше реального.",
    noFeeAmount_many: "У {{count}} наймов нет суммы оплаты перевозчика, поэтому доход показан меньше реального.",
    noFeeAmount_other: "У {{count}} наймов нет суммы оплаты перевозчика, поэтому доход показан меньше реального.",
    expected: "Ожидаемый доход",
    expectedHint: "Оплаты перевозчиков за наймы, одобренные в этом периоде",
    received: "Получено денег",
    receivedHint: "Оплаты перевозчиков, поступившие на счета в этом периоде (Бюджет → Деньги)",
    cost: "Расходы",
    costHint: "Одобренные расходы, зарплаты и бонусы (Бюджет), полные месяцы периода",
    profit: "Прибыль",
    profitHint: "Ожидаемый доход минус расходы",
    costPerHire: "Стоимость найма",
    revenuePerHire: "Доход с найма",
    hiresN_one: "{{count}} найм",
    hiresN_few: "{{count}} найма",
    hiresN_many: "{{count}} наймов",
    hiresN_other: "{{count}} найма",
    chartTitle: "Доход и расходы · 12 месяцев",
    chartSub: "В USD; суммы в UZS — по курсу их дня",
    series: { expected: "Ожидаемый доход", cost: "Расходы", profit: "Прибыль" },
    carriersTitle: "Перевозчики",
    carriersSub: "Наймы этого периода: ожидается, получено и долг",
    branchesTitle: "Филиалы",
    branchesSub: "Наймы, расходы и прибыль по филиалам",
    empty: "В этом периоде наймов нет.",
    col: { carrier: "Перевозчик", hires: "Наймы", expected: "Ожидается", received: "Получено", outstanding: "Долг", status: "Оплаты", branch: "Филиал", cost: "Расходы", profit: "Прибыль", costPerHire: "Стоимость найма" },
    paidN: "оплачено: {{count}}",
    pendingN: "ожидается: {{count}}",
    notPaidN: "не оплачено: {{count}}",
  },
};
